import { render, staticRenderFns } from "./ManageVolunteers.vue?vue&type=template&id=77aa8970&"
import script from "./ManageVolunteers.vue?vue&type=script&lang=js&"
export * from "./ManageVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports